import React from 'react';
import bonequinhoPremiacao from 'assets/img/2026/bonequinho_premiacao.png';
import './PremiadosBannerElbb.scss';

/**
 * Banner de encerramento do Prêmio ELBB. Equivalente ao banner usado na
 * HomePublic, ajustado para a identidade ELBB (texto e tom).
 */
export const PremiadosBannerElbb: React.FC = () => (
  <section className="premiados-banner-elbb-section" aria-labelledby="premiados-banner-elbb-title">
    <div className="premiados-banner-elbb-content">
      <div className="premiados-banner-elbb-text">
        <h1 className="premiados-banner-elbb-title" id="premiados-banner-elbb-title" tabIndex={0}>
          O Prêmio ELBB 2026 chegou ao fim!
        </h1>
        <p className="premiados-banner-elbb-description" tabIndex={0}>
          Após uma jornada de muitas ideias e impacto positivo, celebramos as iniciativas que se destacaram.
        </p>
        <p className="premiados-banner-elbb-congrats" tabIndex={0}>Parabéns a todos os participantes!</p>
      </div>
      <div className="premiados-banner-elbb-illustration">
        <img src={bonequinhoPremiacao} alt="Ilustração de comemoração do Prêmio ELBB 2026" tabIndex={0} />
      </div>
    </div>
  </section>
);
